import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/compras",
    label: "Compras",
    isActive: true,
  },
];

function Compras() {
  return (
    <Page
      title="Compras"
      description="Proceso y listado de compras."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default Compras;
